import { captureAction } from '@smg-real-estate/browser-rum';

import type { RestageTransformation } from './client';

export const OVERTIME_THRESHOLD = {
  RESTAGE_IMAGE: 18000,
} as const;

export const METRICS = {
  RESTAGE_IMAGE_CALL_STARTED: 'restage-image-call-started',
  RESTAGE_IMAGE_CALL_SUCCEEDED: 'restage-image-call-succeeded',
  RESTAGE_IMAGE_CALL_FAILED: 'restage-image-call-failed',
  RESTAGE_IMAGE_CALL_OVERTIME: 'restage-image-call-overtime',
  RESTAGE_IMAGE_CALL_RECOVERED: 'restage-image-call-recovered',
} as const;

interface RestageMetricContext {
  transformation: RestageTransformation;
  platform: string;
  error_type?: string;
}

function getPlatformTag(): string {
  return import.meta.env.VUE_APP_PLATFORM || 'hg';
}

function buildContext(
  transformation: RestageTransformation,
  errorType?: string,
): RestageMetricContext {
  return {
    transformation,
    platform: getPlatformTag(),
    ...(errorType ? { error_type: errorType } : {}),
  };
}

function captureRestageMetric(name: string, context: RestageMetricContext): void {
  if (import.meta.env.SSR) {
    return;
  }

  captureAction(name, context);
}

export function restageImageCallStarted(transformation: RestageTransformation): void {
  captureRestageMetric(METRICS.RESTAGE_IMAGE_CALL_STARTED, buildContext(transformation));
}

export function restageImageCallSucceeded(transformation: RestageTransformation): void {
  captureRestageMetric(METRICS.RESTAGE_IMAGE_CALL_SUCCEEDED, buildContext(transformation));
}

export function restageImageCallFailed(
  transformation: RestageTransformation,
  errorType: string,
): void {
  captureRestageMetric(METRICS.RESTAGE_IMAGE_CALL_FAILED, buildContext(transformation, errorType));
}

export function restageImageCallOvertime(transformation: RestageTransformation): void {
  captureRestageMetric(
    METRICS.RESTAGE_IMAGE_CALL_OVERTIME,
    buildContext(transformation, 'overtime'),
  );
}

export function restageImageCallRecovered(transformation: RestageTransformation): void {
  captureRestageMetric(METRICS.RESTAGE_IMAGE_CALL_RECOVERED, buildContext(transformation));
}
